export default {
  // 考勤
  attendance: {
    attendance: 'attendance',
    attendanceMange: 'attendance management',
    attendanceNote: 'quick punch, easy statistics',
    clockRule: 'clock rules',
    attendanceMethod: 'ways of check on work attendance',
    shiftMangae: 'flight management',
    workforceManage: 'workforce management',
    otherSet: 'other settings',
    associatedApprovalForm: 'Related approval form',
    plugManage: 'Plug-in management',
    attendanceStatistics: 'attendance statistics',
    addAddress: 'Add the address',
    addWIFI: 'add the WiFi',
    placeAttendance: 'Site attendance',
    attendanceName: 'The name of attendance',
    attendanceAdress: 'The address of attendance',
    attendanceNum: 'The number of attendance',
    attendanceType: 'the type of attendance',
    attendanceDate: 'the date of attendance',
    validRange: 'effective range',
    m: 'meter',
    WIFIattendance: 'WiFi attendance',
    WIFIname: 'the name of WiFi',
    macAddress: 'mac address',
    setWIFI: 'set the WiFi',
    wifiName_empty: 'Please enter the WiFi name',
    wifiName_error:
      'Try to keep the name consistent with the name of attendance WiFi to avoid misunderstanding.',
    mac_empty: 'Please enter the MAC address',
    mac_error: 'Please enter the correct MAC address',
    macTip: "Don't know how to set the MAC address?Phone setup is easy.",
    tutorial: 'Click on me to see the tutorial',
    attendanceWayDeleteTip:
      'Note: it is not recoverable after deletion, and the attendance group that applies the attendance location /WiFi will no longer be able to clock in with the address',
    leastOneAddress: 'Please select at least one address',
    leastOneValidRange: 'Please select at least one valid range',
    shiftsName: 'Shift the name',
    maxLengthMust: 'A maximum of 6 characters is required',
    attendanceTime: 'Attendance time',
    commutingTimes: 'commutes',
    workOnceDay: 'Once a day commute',
    workTwiceDay: 'Two commutes a day',
    workthreeDay: 'Three commutes a day',
    addShift: 'Add shift',
    times: 'time',
    shift: 'shift',
    clockTime: 'clock time',
    clockTimeLimit: 'Clock time limit',
    forceClock: 'Mandatory clock',
    first: 'first',
    second: 'second',
    third: 'third',
    gotoWork: 'go to work',
    offDuty: 'off duty',
    nextDay: 'next day',
    needClock: 'Need to clock in',
    noNeedClock: 'No need to clock in',
    restTime: 'break time',
    breakStart: 'Start of the rest',
    breakEnd: 'End of the rest',
    break: 'break',
    time: 'time',
    select: 'select',
    ruleEffectiveTime: 'Select the effective time of the rule',
    effectiveImmediatelyTip:
      'Effective immediately: attendance will be recalculated according to the new rules',
    effectiveTomorrow: 'Come into effect tomorrow',
    effectiveImmediately: 'Effective immediately',
    anyTimeClock: 'You can clock in at any time',
    workBefore15: 'Clock in 15 minutes before starting time',
    workBefore30: 'Clock in 30 minutes before starting time',
    workBefore60: 'Clock in 60 minutes before starting time',
    workBefore90: 'Clock in 90 minutes before starting time',
    workBefore120: 'Clock in 120 minutes before starting time',
    workBefore150: 'Clock in 150 minutes before starting time',
    workBefore180: 'Clock in 180 minutes before starting time',
    workAfter15: 'Clock in within 15 minutes after work',
    workAfter30: 'Clock in within 30 minutes after work',
    workAfter60: 'Clock in within 60 minutes after work',
    workAfter90: 'Clock in within 90 minutes after work',
    workAfter120: 'Clock in within 120 minutes after work',
    workAfter150: 'Clock in within 150 minutes after work',
    workAfter180: 'Clock in within 180 minutes after work',
    shiftsName_empty: 'The flight name cannot be empty',
    timeSequence_error: 'Please set the time points in chronological order',
    addAttendanceGroup: 'Add attendance group',
    fixedShiftSystem: 'Fixed shifts system',
    schedulingSystem: 'The scheduling system',
    freeWorkingHours: 'free working hours',
    weekly: 'Every Week',
    clockAtAnyTim: 'Do not set the shift, punch at any time',

    scheduling: 'scheduling',
    stepOne: 'Step 1: download the scheduling list',
    stepTwo: 'Step 2: import the scheduling list',
    attendanceScheduling: 'Attendance scheduling',
    schedulingPeriod: 'Scheduling cycle',
    adjusted: 'adjusted',
    item: 'item',
    recover: 'recover',
    addRosterPeriod: 'Add scheduling cycles',
    cycleName: 'Cycle name',
    cycleNameLength: 'Please enter the period name, limited to 6 words',
    cucleDay: 'Cycle day',
    cycle: 'cycle',
    shiftTime: 'length of shift',
    di: 'first left',
    restDay: 'On the day of the rest',
    hugh: 'rest',
    discardSave: 'Are you sure to abandon the save',
    dataNotSaved: 'The current month scheduling data has not been saved',
    attendanceManage: 'Attendance manager',
    saveSet: 'save settings',
    clockReminder: 'Clock reminded',
    wordTimeBefore: 'Before office hours',
    remindWorkCard: 'Minutes, to remind employees to punch in.',
    afterHours: 'after hours',
    remindClockOut: 'Minutes, remind the staff to hit the card.',
    listSet: 'List Settings',
    allGroupTogether: 'All attendance groups are counted together',
    attendanceGroupstatistics: 'Separate statistics according to the attendance group',
    earlyArrivalList: 'early arrival list',
    listStatistics: 'List statistical method',

    statisticsEveryDayBefore: 'Statistics each day before',
    punchCardSituation: 'ranking of the clock',
    diligenceList: 'List of diligence',
    statisticsEveryMonthBefore: 'Statistics before each month ',
    lateList: 'List of late',
    lateStatisticsMethod: 'Lateness statistics',
    lateness_error:
      'Sort by lateness.The higher the number of lateness, the higher the number of lateness, and the higher the number of lateness',
    lateHours_error:
      'Sort by lateness.The longer the tardiness, the higher the order, and the same tardiness, the more tardiness.',
    lateArrivalAndLateDeparture: 'be late and stay late',
    firstDayLeaveLate: 'Stay late after work on your first day',
    nextDayLeaveLate: 'Late to work the next day',
    humanizedShift: 'Humanized shift',
    everyMonthLate: 'Lateness is allowed every month',
    lateOneTimeAllowed: 'Single lateness is allowed',
    singleLate: 'More than once late',
    singleLeaveEarly: 'Single early leave over',
    absenteeismRules: 'Absenteeism rules',
    recordedAbsenteeism: 'Minutes, recorded as absenteeism.',
    absenteeismRulesTip:
      "Default absenteeism rule: people who don't clock in and out of work are counted as absenteeism",
    error1: 'Only integers greater than or equal to 0 can be entered',
    error2: 'Only integers greater than 0 can be entered',
    late: 'be late',
    lateTime: 'late time',
    leaveEarly: 'leave early',
    lateTime_error: 'Lateness is not allowed to exceed the time set by the absenteeism rule',
    absenteeismRules_error:
      'Absenteeism rule setting time shall not be less than the allowable late time',
    lateDepartureTime: 'late departure time',
    workBefore: 'before going to work',
    goOffWorkBefore: 'before going off duty',
    ci: 'time',
    articlePage: 'article/page',
    numberShifts: 'number of shifts',
    scheduleByDay: 'According to the days of scheduling',
    scheduleByCycle: 'Schedule by cycle',
    modifyshift: "Modify the employee's shift of the day",
    thisDayToEndOfMonth: 'Start the cycle from that day to the end of the month',
    name: 'name',
    statistics: 'statistics',
    modifyTips: 'Only the current month and the schedule of last month can be modified',
    attendanceGroup: 'Group of check on work attendance',
    attendanceGroupName: 'Name of attendance group',
    attendanceGroupNameLength10:
      'Please enter the name of the attendance record, no more than 10 words',
    attendanceName_empty: 'The attendance name cannot be empty',
    attendanceOfficer: 'Attendance personnel',
    attendanceOfficer_empty: 'Attendance staff can not be empty',
    noAttendanceRequired: 'No attendance staff required',
    sameTime: 'Same attendance time every day',
    sameTimeTip:
      'Suitable for: IT, finance, cultural media, government/public institutions, education and training industries',
    weekdays: 'workday',
    legalHolidays: 'Statutory holidays are automatically arranged',
    customAttendanceTime: 'Custom set attendance time',
    customAttendanceTimeTip:
      'Suitable for: catering, manufacturing, logistics trade, customer service, hospital and other industries',
    shiftTip:
      'After saving the clocking rule, please go to "scheduling management" to set the scheduling for the members in the current rule',
    noShiftTip:
      'Shift is not regular, decoration, housekeeping, logistics and other computing hours of the industry',
    specialClock: 'Special clock',
    mustPunchDate: 'must punch the date',
    date: 'date',
    editShift: 'Edit shifts',
    noClockDate: 'No punch dates',
    setWeekdays: 'Set working days',
    attendanceStartTime: 'attendance start time',
    attendanceStartTimeTip: 'What time does the attendance begin every day',
    attendanceTypeTip:
      'The following ways meet one item, the attendance group members can complete the attendance',
    attendanceTypeTip1:
      'Attendance based on office location (multiple attendance locations can be added)',
    addAttendanceAddress: 'Add attendance address',
    attendanceTypeTip2:
      'According to WiFi attendance (multiple office WiFi can be added when located in the office accurately)',
    addWIFIAddress: 'add the WIFI address',
    allowClock: 'Field punches are allowed',
    punchClock: 'Punch in for face recognition',
    addData: 'Add the date',
    multipleShiftTypes: 'A variety of flight types are available',
    setUpShifts: 'Set the divisions',
    selectShift: 'Select shift',
    pleasSelectShift: 'Please select shift',
    attendanceWifiAddress_error:
      'One item must be set according to office attendance and WiFi attendance',
    dateRepeated: 'Date repeated',
    data_empty: 'The date cannot be empty',
    redPacket: 'red packet',
    redPacketNote: 'After successful attendance bonus to motivate employees',
    addRule: 'Add rules',
    rewardContent: 'Reward content',
    numberAwards: 'Number of reward',
    rewardAmount: 'amount of reward',
    shake: 'shake',
    faceRecognition: 'face recognition',
    faceRecognition2: 'Accurate face recognition, take photos to complete the clock',
    fastPunch: 'fast punch',
    fastPunch2:
      'You only need to open the app during the attendance period, and the system will automatically help you complete the punch',
    connectAttendanceMachine: 'Connect to the attendance machine',
    connectAttendanceMachine2:
      'Get through both online and offline platforms, complete summary of attendance data (only support designated attendance machine)',
    redPacketSet: 'the setting of the red packet',
    redPacketSetTip1:
      'The early arrival list is a daily updated list of the earliest employees who come to the company every day.',
    redPacketSetTip2:
      'Red pocket is awarded immediately, and the red pocket will be sent as long as the punch card is in the winning range.',
    topOfList: 'the top',
    ranking: 'ranking',
    distributionMethod: 'mode of distribution',
    average: 'average',
    random: 'random',
    custom: 'custom',
    allAttendanceRecords: 'All attendance records',
    dailySummary: 'The daily summary',
    monthlySummary: 'A monthly summary',
    exceptionRecord: 'exception record',
    fieldName: 'The field names',
    clockAddress: 'Clock in address',
    clockResults: 'clock the results',
    week: 'week',
    remark: 'remark',
    clockEquipment: 'Punching equipment',
    fieldPersonnel: 'Legwork',
    month: 'month',
    attendanceDays: 'attendance day',
    daysOff: 'Rest days',
    workingHours: 'working hours',
    lateTimes: 'The number of late',
    lateRecord: 'Late for record',
    lengthOfBeingLate: 'The late time',
    earlyLeaveTimes: 'early leave times',
    earlyLeaveRecord: 'Early  leave records',
    lengthOfEarlyLeave: ' length of early leave',
    cardMissingTimes: 'Lack of card times',
    cardMissingTimes2: 'Time to clock in: lack of a card',
    cardMissingRecord: 'Lack of card record',
    numberCardsMissingFromWork: 'Card shortage times after work',
    numberCardsMissingFromWork2: 'Time to clock in: card shortage after work',
    absenteeismDays: 'Absenteeism days',
    attendanceRequiredDays: 'Days of attendance required',
    lateAbsenteeism: 'Late absenteeism',
    earlyLeaveAbsenteeism: 'Leave early absenteeism',
    clockTimeAbsenteeism: 'Time to clock in: absent from work',
    leave: 'leave',
    overtime: 'overtime',

    yymmdd: 'year,month,day',
    yymmddhhmm: 'year,month,day',
    editRecord: 'Modify record',
    normal: 'normal',
    modifyReason: 'Modify the reason',
    minute_empty: 'Minutes cannot be empty',
    modifyTip1: 'Will punch out the result',
    modifyTip2: 'Changed to',
    modifyTip3: 'Modify the reason',
    arrive: 'reach',

    goout: 'go out',
    changeFlight: 'Change shift',
    evection: 'evection',
    reissue: 'Card replacement',
    addPersonnel: 'Add people',
    synchronousPersonnel: 'Synchronization personne',
    serialNumber: 'Serial number',
    machineNumber: 'Employee number of corresponding person in attendance machine',
    attendanceMachine: 'Attendance machine',
    attendanceMachineManufacturer: 'Attendance machine manufacturer',
    attendanceMachineName: 'Name of attendance machine',
    attendanceMachineName_error: 'Attendance machine name cannot be empty',
    attendanceMachineSN: 'Attendance machine SN',
    timingTime: 'Timing time',
    timingTime_error: 'Timing time cannot be empty',
    synchronousTime_error: 'Synchronization time cannot be empty',
    attendanceMachineSN_error: 'Attendance machine Sn cannot be empty',
    timeInterval_error: 'Time interval cannot be empty',
    attendanceMachineTip: 'Attendance machine - Equipment Information - serial number',
    attendanceMachineDeleteTip: 'Are you sure you want to delete the attendance machine?',
    off: 'to break off',
    sameAttendanceGroup:
      'Only shift scheduling personnel of the same attendance group should be replaced',
    signatureCardType: 'Make up type',
    cardReplacementTime: 'Card replacement time',
    overtimeType: 'Overtime type',
    leaveType: 'Leave type',
    why: 'reason',
    selected: 'Selected',
    arecord: 'Records',
    importedTip:
      'Please prepare the data to be imported according to the format of the data template',
    notes: 'matters needing attention',
    notes1:
      '1. The header name in the template cannot be changed and the header row cannot be deleted;',
    notes2:
      '2. The import format is xlsx. The maximum number of uploads is 10000, and the file size is no more than 20m;',
    notes3:
      '3. Name, attendance group, attendance date, attendance time and clock in time are required;',
    notes4:
      '4. If the name is the same, please fill in the job number matching personnel attendance;',
    notes5:
      '5. The imported data is only for card shortage status data, and can not be imported and updated without card shortage status;',
    importTemplate: 'Click here to download the data import template',
    addFile: 'Add file',
    startImporting: 'Start importing',
    synchronizingData: 'Synchronize historical data',
    startSync: 'Start syncing',
    laterData: 'Data after',
    realTimeSync: 'Real time synchronization',
    timing: 'timing',
    syncBetween: 'Interval synchronization',
    attendanceMachineTip2:
      'Please configure which attendance machine data you need to obtain and synchronize personnel for each attendance machine.',
    every: 'every other',
    getAttendanceData: 'Get attendance data once a minute',
    effectiveStartTime: 'Effective start time',
    effectiveEndTime: 'Effective end time',
    startAndEndTime_error: 'Start time cannot be greater than or equal to end time',
    overtimeTime_empty: 'Overtime duration cannot be empty',
    overtimeTime_error: 'Format error of overtime duration',
    yuanyin_error: 'Reason cannot be empty',
    fileFormatError: 'File format error',
    onelateminute: 'Minutes late for a single time',
    cumulativelateminute: 'Cumulative minutes late',
    autoMatchTip:
      'When the shift is not scheduled, the shift can be intelligently matched or manually modified',
    correctedstate: 'Correction status',
    cardreplacementrule: 'Card replacement rules',
    annualleaverule: 'Annual leave rules',
    overtimerule: 'Overtime rules',
    lackofapprovalcard:
      'After approval, the "card missing" status in this period will be automatically corrected to "normal".',
    afterapprovalmonthlystatistics:
      'after approval, the approval form will be included in the attendance monthly statistics',
    cardreplacementtimefield: 'Corresponding field of card replacement time',
    starttimecorrespondstotime: 'Start time corresponding time',
    endtimecorrespondstotime: 'End time corresponding time',
    fieldcorrespondingtolength: 'Corresponding field of duration',
    itemTip1: 'This item is used to deduct the balance of annual leave and compensatory leave',
    numberofcardrepayments: 'Limit the number of card replacement: it can be submitted every month',
    secondaryreplacementcard: 'Secondary card replacement',
    calculatedfromnaturalmonth: '(calculated from natural month)',
    limitedreplacementtime: 'Limited time for card replacement: you can apply in the past',
    replacementcardwithindays: 'Card replacement within days',
    fillindaysTip:
      '(if you fill in 0 days, you can only initiate the card replacement on that day)',
    calculationofapprovaltime:
      'It is calculated according to the time length of the approval document',
    calculatedbyclockingtime: 'Calculated by clock in time',
    overtimeTip1: 'Minutes later, start to count as overtime',
    overtimeTip2: 'Overtime less than',
    overtimeTip3: 'Minutes, not counted as overtime',
    missingcard: 'Card shortage',
    leaveclearance: 'Cancellation of leave',
    replacementcardnumber_error: 'Format error of limit card replacement times',
    replacementcardtime_error: 'Wrong format of time limit for card replacement',
    pleaseenterintegers0720: 'Please enter an integer of 0-720',
    associatedapprovalform_empty: 'Please select the associated approval form',
    fixstatus_empty: 'Please select correction status',
    typeofleave_empty: 'Please select leave type',
    overtimetype_empty: 'Please select overtime type',
    thetimecorrespondingtothestarttime_empty: 'Please select the start time corresponding time',
    thetimecorrespondingtotheendtime_empty: 'Please select the corresponding time of end time',
    thefieldcorrespondingtoduration_empty: 'Please select the corresponding field of duration',
    thefieldcorrespondingtocardreplacementtime_empty:
      'Please select the corresponding field of card replacement time',
    addattendancemachine: 'Add attendance machine',
    enterattendancemachine: 'Enter attendance machine',
    pushTip: 'Push (attendance machine supporting B / S architecture)',
    offline: 'offline',
    attendancedockingaddress: 'Attendance docking address',
    modeofcommunication: 'Communication mode',
    attendancemachine_serialnumber: 'Attendance machine - Equipment Information - serial number',
    ipaddress: 'IP address',
    port: 'port',
    communicationpassword: 'Communication password',
    fetchtime: 'Data acquisition time',
    centralcontrol: 'Central control',
    ipcannotbeempty: 'IP cannot be empty',
    ipformaterror: 'IP format error',
    portcannotbeempty: 'Port cannot be empty',
    communicationpasswordcannotbeempty: 'Communication password cannot be empty',
    syncmode: 'Synchronous mode',
    interfacetype: 'Interface type',
    communicationmode: 'Communication mode',
    attendancemachinehasbeenrepeated: 'Attendance machine repeated',
    punchinaccordingtoattendancemachine: 'Clock in according to attendance machine',
    connectattendancemachinesettings:
      '(please set it in plug-in management > connection attendance machine)',
    atleastoneattendancemethod: 'Please select at least one attendance method',
    pleaseaddattendanceaddress: 'Please add attendance address',
    returnlist: 'Back to list',
    annualleavesetting: 'Annual leave setting',
    switchoffsetting: 'Compensatory leave setting',
    holidaybalance: 'Leave balance',
    setemployeeannualleavebalance: 'Set employee annual leave balance',
    annualleave: 'annual leave',
    balancesendingmode: 'Balance sending method',
    releasedate: 'Date of issue',
    correspondstotheentrydatein: 'It corresponds to the entry date in [member management]',
    quotaallocationrules: 'Quota configuration rules',
    perpersonperyear: 'Annual distribution per person',
    fullage: 'The secretary is full of age',
    yeardiscontent: 'year,Dissatisfaction',
    annualsabbatical: "Year's,Vacation available",
    yearannualleaveallowed: 'year,Annual leave available',
    expirationdate: 'term of validity',
    yearfromthedateofissue: '1 anniversary from issue date',
    allowedextensionofvalidityperiod: 'Extension of validity allowed',
    afterexpirybalanceretained: 'After the expiration date, the balance is retained',
    setasrestshift: 'Set as compensatory leave',
    leaveofabsence: 'Ask for leave',
    overtimeshiftonweekdays: 'Working day overtime Compensatory leave',
    overtimeshiftonrestday: 'Working overtime on rest days Compensatory leave',
    workingovertimeonholidays: 'holiday overtime Compensatory leave',
    press1: 'Press 1:',
    afterhowmanydaysofovertime: 'How many days after overtime to void',
    voidafterday: 'Void in days',
    howmanydaysexpireaftertoday: 'After setting today, how many days will it expire',
    entrydate: 'Entry date',
    record: 'record',
    editannualleave: 'Edit annual leave',
    editleave: 'Edit vacation',
    modifybalance: 'Modify balance',
    issuedautomaticallyonceayear: 'Automatic distribution once a year',
    january1steachyear: 'January 1 of each year',
    annualemployeeentryday: 'Annual employee entry day',
    fixedquota: 'Fixed amount',
    byseniority:
      "According to the company's seniority(The length of service of the company is the unit)",
    increase: 'increase',
    reduce: 'reduce',
    annualleavecannotbeempty: 'Annual leave cannot be blank',
    fixedlimitformaterror: 'Fixed quota format error',
    quotaruleformaterror: 'Quota rule format error',
    leaveleavecannotbeempty: 'Leave for compensatory leave cannot be empty',
    atleastonetypeofovertime: 'Please select at least one overtime type',
    wrongformatofworkingovertimeshiftrate: 'Wrong format of working day overtime compensation rate',
    wrongformatofovertimeshiftratioonrestday:
      'Format error of overtime compensation rate on rest days',
    wrongformatofovertimeworkingrateonholidays:
      'Incorrect format of holiday overtime compensation rate',
    invaliddayscannotbeempty: 'Void days cannot be blank',
    invalidnumberofdaysformattedincorrectly: 'Invalid days format error',
    calculatedastimeoff: 'It is counted as the rest time',
    transferleave: 'Compensatory leave',
    absenteeism: 'Absenteeism',
    verify: 'verification',
    sameattendancegroup_error: 'Please check the same attendance group',
    length: 'Duration',
    originalshift: 'Original shift',
    timeperiod: 'time slot',
    nodataavailable: 'There is no operational data',
    effectiveRange: 'Valid range of punch in',
    ruleContent: 'Content of rules',
    // 20210305
    importtemplate: 'Attendance import template',
    test: '123'
  }
}
